<template>
  <v-col md="6">
    <div class="mt-5 mb-3 ml-2">

      <div style="display: flex;justify-content: space-between;align-items: center;">
        <h2 v-if="showUsageInfo">사용정보</h2>
        <h2 v-if="!showUsageInfo">루트정보</h2>

        <div>
          <TextButton buttonText="사용정보" small class="mr-2" :class="{ active: showUsageInfo }" @click="showUsageInfo = true" 
            v-if="userStatus === 'admin'" />
          <TextButton buttonText="루트정보" small :class="{ active: !showUsageInfo }"  @click="adminuseuserdata"
            v-if="userStatus === 'admin'" />
        </div>
      </div>

    </div>
    <v-simple-table class="usage_table ml-2" v-if="showUsageInfo">
      <template>
        <thead>
          <tr class="table_wrap">
            <th class="text-left table_title pa-4" style="border-top: 1px solid rgb(0, 0, 0);
                color: #000;
                font-size: 16px;">
              스토리지 사용량
            </th>
            <th class="text-left table_text" style="border-top: 1px solid rgb(0, 0, 0);
                font-size: 16px;
                font-weight:400;">
              {{ userStorage }}
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
                font-size: 16px;">
              CDN 트래픽 사용량
            </th>
            <th class="text-left table_text" style="font-size: 16px;
                font-weight:400;">
              <div v-if="errorMessage">
                {{ errorMessage }}
              </div>
              <div v-else>
                {{ trafficUsage }} ({{ periodTrafficStart }} ~ {{ periodTrafficEnd }})
              </div>
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
                font-size: 16px;">
              인코딩 사용량
            </th>
            <th class="text-left table_text" style="font-size: 16px;
                font-weight:400;">
              {{ userEncoding.totalSize }} ( {{ userEncoding.startDate }} ~ {{ userEncoding.endDate }} )
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
                font-size: 16px;">
              동영상 에셋수
            </th>
            <th class="text-left table_text" style="font-size: 16px;
                font-weight:400;">
              {{ userAssetCount }} Files
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="border-bottom: 1px solid rgb(0, 0, 0);
                color: #000;
                font-size: 16px;">
              Live
            </th>
            <th class="text-left table_line" style="border-bottom: 1px solid rgb(0, 0, 0);
                font-size: 16px;
                font-weight:400;">
              {{ liveCount }}
            </th>
          </tr>
        </thead>
      </template>
    </v-simple-table>

    <v-simple-table class="root_table ml-2" v-if="!showUsageInfo">
      <template>
        <thead>
          <tr class="table_wrap">
            <th class="text-left table_title pa-4" style="border-top: 1px solid rgb(0, 0, 0);
                color: #000;
                font-size: 16px;">
              스토리지 사용량
            </th>
            <th class="text-left table_text" style="border-top: 1px solid rgb(0, 0, 0);
                font-size: 16px;
                font-weight:400;">
              {{ this.userDataStorage }}
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
                font-size: 16px;">
              CDN 트래픽 사용량
            </th>
            <th class="text-left table_text" style="font-size: 16px;
                font-weight:400;">
              <div v-if="errorMessage">
                {{ errorMessage }}
              </div>
              <div v-else>
                {{ trafficUsage }} ({{ periodTrafficStart }} ~ {{ periodTrafficEnd }})
              </div>
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
                font-size: 16px;">
              인코딩 사용량
            </th>
            <th class="text-left table_text" style="font-size: 16px;
                font-weight:400;">
              {{ userDataEncoding.totalSize }} ( {{ userDataEncoding.startDate }} ~ {{ userDataEncoding.endDate }} )

            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="color: #000;
                font-size: 16px;">
              동영상 에셋수
            </th>
            <th class="text-left table_text" style="font-size: 16px;
                font-weight:400;">
              {{ userDataAssetCount }} Files
            </th>
          </tr>
          <tr>
            <th class="text-left table_title pa-4" style="border-bottom: 1px solid rgb(0, 0, 0);
                color: #000;
                font-size: 16px;">
              Live
            </th>
            <th class="text-left table_line" style="border-bottom: 1px solid rgb(0, 0, 0);
                font-size: 16px;
                font-weight:400;">
              {{ userDataLive }}
            </th>
          </tr>
        </thead>
      </template>
    </v-simple-table>
  </v-col>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton2.vue';
import DashboardApi from "@/api/dashboard/DashboardApi";
import { mapState, mapActions, mapGetters } from 'vuex';

export default {

  components: {
    TextButton
  },
  data() {
    return {
      active: false,
      showUsageInfo: true,
      userDataLive: '',
      userDataAssetCount: '',
      userDataStorage: '',
      userDataEncoding: '',
    }
  },
  computed: {
    ...mapState('dashboard', {
      userStorage: state => state.userStorage,
      userEncoding: state => state.userEncoding,
      liveCount: state => state.liveCount,
      userAssetCount: state => state.userInfo.asset_count,
      domainNotFound: state => state.domainNotFound,
      trafficUsage: state => state.trafficUsage,
      periodTrafficStart: state => state.periodTrafficStart,
      periodTrafficEnd: state => state.periodTrafficEnd,
      errorMessage: state => state.errorMessage
    }),
    ...mapGetters('user', ['userStatus']),
  },
  methods: {
    ...mapActions('dashboard', ['data', 'tencentData']),
    async adminuseuserdata() {
      this.showUsageInfo = false;
      const url = window.location.protocol + '//' + window.location.host;
      const response = await DashboardApi.guestData({ url });
      //console.log('res-dash', response);

      this.userDataLive = response.liveCount;
      this.userDataAssetCount = response.asset_count;
      this.userDataStorage = response.userStorage;
      this.userDataEncoding = response.userEncoding;


    }
  },
  created() {
    this.tencentData();
  }
}
</script>

<style scoped>
.active {
  background-color: #ddd;
  /* 활성화된 버튼의 배경색 */
  color: red;
  /* 활성화된 버튼의 텍스트 색상 */
}
</style>